import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("noxai_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
